<template>
  <div class="view-leads">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ $t('labels.review') }}</h2>
      </div>
    </div>
    <div class="inspect-question">
      <div>
        <view-project :project="project"></view-project>
      </div>
      <vx-card :title="$t('labels.select_consultant_service')">
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 lg:w-1/2 sm: p-0 md:pr-4">
            <label class>{{ $t('labels.consultant')}}</label>
            <v-select
              v-model="consultant"
              :options="consultants"
              :reduce="consultants => consultants.id"
              :value="$store.myValue"
              @input="setSelectedCon"
              label="name"
              name="consultants"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/2 lg:w-1/2 sm: mt-6 md:mt-0 sm: p-0 md:pl-4">
            <label class>{{ $t('labels.service')}}</label>
            <v-select
              v-model="service"
              :options="services_drop"
              :reduce="services_drop => services_drop.id"
              label="name"
              name="service"
              :value="$store.myValue"
              @input="setSelectedSer"
            />
          </div>
        </div>
      </vx-card>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-4 float-right flex">
            <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-filter"
              @click="showfilter = !showfilter"
              :disabled="!this.consultant || !this.service"
              class="mr-2 btn-color"
            >{{ $t('labels.filter') }}</vs-button>
          </div>
        </div>
      </div>
      <vx-card class="filter_card mt-4" v-show="showfilter ==  true">
        <div class="vx-row filter-default">
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t('labels.section')}}</label>
            <v-select
              v-model="section"
              :options="filterSection"
              :reduce="filterSection => filterSection.id"
              label="name"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t('labels.designation')}}</label>
            <v-select
              v-model="designation"
              :options="filterDesignation"
              :reduce="filterDesignation => filterDesignation.id"
              label="name"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t('labels.query_status')}}</label>
            <v-select
              v-model="query_status_filter"
              :options="filterQueryStatus"
              :reduce="filterQueryStatus => filterQueryStatus.value"
              label="label"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col md:w-2/3">
            <label class="pl-1">{{ $t('labels.search')}}</label>
            <vs-input icon-pack="feather" icon="icon-search" v-model="search" class="w-full" />
          </div>
          <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
            <vs-button
              color="maroon"
              type="filled"
              icon-pack="feather"
              icon="icon-x"
              :title="$t('labels.filter')"
              @click="clearFilter()"
              :disabled="!this.section && !this.designation && !this.query_status_filter && !this.search"
              class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t('labels.clear') }}</vs-button>
          </div>
        </div>
      </vx-card>
      <!-- pagination start-->
      <div class="mt-6 question-pagination" v-if="service">
        <div class="vx-row">
          <div class="vx-col sm: w-full md:w-1/2 sm: order-2 md:order-1 sm: mt-4 md:mt-0">
            <vs-chip
              color="primary"
              class="mt-2 ml-1"
            >{{start+1}} - {{end>question_length?question_length:end}} of {{question_length}}</vs-chip>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 sm: order-1 md:order-2">
            <vs-pagination color="dark" :total="pageCount" v-model="currentx" class="mb-1"></vs-pagination>
          </div>
        </div>
      </div>
      <!-- pagination end-->
      <div class="vx-row w-full mx-0">
        <div class="vx-col sm: w-full mt-6">
          <div class="vx-row mb-6">
            <div class="w-full" v-for="(question,qindex) in filtered_questions" :key="qindex">
              <vx-card
                :title="'--'+question.section_reference_number+'-- '+ question.question"
                class="mb-6"
              >
                <!-- For admin -->
                <vx-card class="add-query">
                  <div class="flex justify-center">
                    <vs-button
                      @click="getComments(qindex)"
                      color="dark"
                      type="border"
                    >{{ $t('labels.chat') }}</vs-button>
                    <div
                      v-if="question.project_consultant_service_question.query_status !== 'R'"
                      class
                    >
                      <vs-button
                        @click="getProjectChangeQueryStatus(question.project_consultant_service_question.id, 'R')"
                        class="ml-6"
                        color="warning"
                        value="R"
                        type="border"
                      >{{ $t('labels.raise_query') }}</vs-button>
                    </div>​
                    <div
                      class="vx-col"
                      v-if="(['R','A']).includes(question.project_consultant_service_question.query_status)"
                    >
                      <vs-button
                        @click="getProjectChangeQueryStatus(question.project_consultant_service_question.id, 'MR')"
                        class="ml-6"
                        color="primary"
                        value="MR"
                        type="border"
                      >{{ $t('labels.mark_as_resolved') }}</vs-button>
                    </div>
                  </div>
                </vx-card>

                <!-- For admin end -->
                <div class="vx-col sm: w-full mt-6">
                  <div class="vx-row mb-4 w-full">
                    <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                      <label class>{{ $t('labels.defect')}}:</label>
                    </div>
                    <div class="vx-col sm: w-1/2 mb-4">
                      <span>{{question.project_consultant_service_question.defect && question.project_consultant_service_question.defect.name}}</span>
                    </div>
                  </div>

                  <div class="vx-row mb-4">
                    <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                      <label class>{{ $t('labels.answer')}}:</label>
                    </div>
                    <div class="vx-col sm: w-1/2 mb-4">
                      <span>{{question.project_consultant_service_question.answer_text}}</span>
                    </div>
                  </div>

                  <div
                    class="vx-row mb-4"
                    v-if="question.project_consultant_service_question.answer_attachment"
                  >
                    <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                      <label class>{{ $t('labels.audio_file')}}:</label>
                    </div>
                    <div class="vx-col sm: w-1/2 mb-4">
                      <div class="vx-row">
                        <div class="vx-col sm: w-full">
                          <p
                            class="self-center sm: mb-0"
                            id="audio_name"
                          >{{ getFileName(question.project_consultant_service_question.answer_attachment) }}</p>
                        </div>
                        <div class="vx-col sm: w-full">
                          <audio controls :id="'audio_control_exit'+qindex">
                            <source
                              :src="question.project_consultant_service_question.answer_attachment"
                              type="audio/mpeg"
                              :id="'audio_source'+qindex"
                            />
                          </audio>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-row mt-6 justify-center mb-6">
                  <div class="vx-col sm: w-full md:w-4/5">
                    <label class="bold-fields justify-center">{{ $t('labels.answer_images')}}</label>
                    <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                      <swiper-slide
                        v-for="image in question.project_consultant_service_question.images"
                        :key="image.path"
                      >
                        <img
                          class="swiper-lazy answer-image"
                          :data-src="image.path"
                          alt="answer-image"
                        />
                        <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                      </swiper-slide>
                      <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                      <div class="swiper-button-prev" slot="button-prev"></div>
                      <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                  </div>
                </div>
                <div
                  class="query-status"
                  v-if="question.project_consultant_service_question.query_status !== 'N'"
                >
                  <vs-chip
                    color="primary"
                    class="mt-2 ml-1"
                  >{{question.project_consultant_service_question.query_status_name}}</vs-chip>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <vs-popup class="holamundo" :title="$t('labels.write_comment')" :active.sync="popupActive">
          <div>
            <div class="vx-row" v-for="(comment,cindex) in comments" :key="cindex">
              <div class="vx-col w-1/7">
                <vs-avatar :text="comment.user.name" color="dark" size="40px" text-color="white" />
              </div>
              <div class="vx-col w-10/12 label-center">
                <label class="comment-avatar">{{comment.comment}}</label>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/7">
              <vs-avatar
                :text="this.$store.state.userInfo.name"
                color="dark"
                size="40px"
                text-color="white"
              />
            </div>
            <div class="vx-col w-10/12">
              <vs-textarea
                type="text"
                class="w-full mb-0 mt-1"
                name="comment"
                id="comment"
                maxlength="5000"
                v-model="comment"
                :placeholder="$t('strings.add_new_comment')"
                icon-no-border
              />
            </div>
          </div>
          <div class="mt-6 submit-btn">
            <vs-button
              class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
              color="primary"
              :disabled="button_loading"
              id="save-answer"
              button="submit"
              @click="addProjectQuestionComments()"
            >{{ $t('labels.submit') }}</vs-button>
          </div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import ViewProject from "@/layouts/components/projects/view-project.vue";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      answer_text: "",
      cancel: "",
      images: [],
      service: "",
      services_drop: [],
      consultant: null,
      consultants_drop: [],
      consultants: [],
      raw_consultants: [],
      questions: "",
      selected_con: "",
      selected_ser: "",
      question: [],
      consultant_services_array: [],
      question_drop: [],
      service_ids: "",
      admin_query: "",
      id: this.$route.params.id,
      model: "project",
      defects: [],
      defect_id: null,
      defects_drop: [],
      popupActive: false,
      project_consultant_service_question_id: [],
      query_status_name: [],
      comments: [],
      comment: "",
      selected_question_index: null,
      project: {},
      currentx: 1, // current page
      question_length: 0, // length of all questions
      perPage: 10, // perPage
      start: 1,
      end: 10,
      swiperOption: {
        // Enable lazy loading
        lazy: true,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      showfilter: false,
      search: "",
      designation: "",
      section: 0,
      query_status_filter: "",
      filterSection: [{ name: "All Section", id: 0 }],
      filterDesignation: [{ name: "All Designation", id: "" }],
      filterQueryStatus: [
        { label: "All Query", value: "" },
        { label: "No Query", value: "N" },
        { label: "Query Reolved", value: "MR" },
        { label: "Query Raised", value: "R" },
        { label: "Query Answered", value: "A" }
      ]
    };
  },
  watch: {
    selected_con(val) {
      // if con drop is cleared than clear service and its drop
      if (!val) {
        this.service = null;
        this.services_drop = [];
      }
    }
  },
  components: {
    VueUploadMultipleImage,
    ViewProject,
    swiper,
    swiperSlide
  },
  computed: {
    filtered_questions() {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      let questions = [];
      let that = this;
      consultants.forEach(function(el) {
        if (el.id == con_target) {
          el.project_consultant.services.forEach(function(el) {
            if (el.id == ser_target) {
              questions = el.project_consultant_service.questions;

              //start filter process

              if (questions.length > 0) {
                questions = questions.filter(function(que) {
                  let designationFlag = false;
                  let sectionFlag = false;
                  let statusFlag = false;
                  let searchFlag = false;
                  if (que.all_designations || !that.designation)
                    designationFlag = true;
                  else
                    que.designations.forEach(function(d) {
                      if (d.id == that.designation) designationFlag = true;
                    });

                  if (que.section_id == that.section || !that.section)
                    sectionFlag = true;
                  if (
                    que.project_consultant_service_question.query_status ==
                      that.query_status_filter ||
                    !that.query_status_filter
                  )
                    statusFlag = true;
                  if (
                    !that.search ||
                    que.question
                      .toLowerCase()
                      .includes(that.search.toLowerCase())
                  )
                    searchFlag = true;
                  return (
                    designationFlag && sectionFlag && statusFlag && searchFlag
                  );
                });
              }
              that.question_length = questions.length;
            }
          });
        }
      });
      /**
      Main Pagination Logic
      start = currentpage - 1 * perpage
       */
      (this.start = (this.currentx - 1) * this.perPage),
        (this.end = this.start + this.perPage);
      return questions.slice(this.start, this.end);
    },
    pageCount() {
      let l = this.question_length,
        s = this.perPage;
      return Math.ceil(l / s);
    }
  },
  mounted() {
    this.getProject();
    this.getSections();
    this.getDesignations();
  },
  methods: {
    clearFilter() {
      this.search = null;
      this.designation = "";
      this.section = 0;
      this.query_status_filter = "";
      this.getProject();
    },
    getComments(qindex) {
      this.popupActive = true;
      this.selected_question_index = qindex;
      this.comments = this.filtered_questions[
        qindex
      ].project_consultant_service_question.comments;
    },
    setSelectedCon(value) {
      this.selected_con = value;
      // get services for selected cont
      let consultants = this.raw_consultants;
      var selectedCon = consultants.filter(function(el) {
        return el.id == value;
      });
      let service_req = selectedCon[0].project_consultant.services;
      let filteredServices = [];
      for (var i = 0; i < service_req.length; i++) {
        let obj = { id: service_req[i].id, name: service_req[i].name };
        filteredServices.push(obj);
      }
      this.services_drop = filteredServices;
    },
    setSelectedSer(value) {
      this.selected_ser = value;
    },
    // API Integration for getData
    async getProject() {
      let response = await this.getHTTPGetResponse(
        "/projects/get/" + this.$route.params.id
      );
      if (response) {
        let data = response.data;
        let project = data.project;
        this.project = data.project;
        this.raw_consultants = project.consultants;
        let consultants = project.consultants;

        let filteredConsultants = [];
        for (var i = 0; i < consultants.length; i++) {
          let obj = { id: consultants[i].id, name: consultants[i].name };
          filteredConsultants.push(obj);
        }
        this.consultants = filteredConsultants;

        // Map
        setTimeout(() => {
          let consultant_services_data = [];
          consultants.forEach(consultant => {
            var services = consultant.project_consultant.services;
            let ser_id = [];
            services = services.forEach(serve => {
              let squestions = serve.project_consultant_service.questions;
              squestions.forEach(que => {});
              let obj = {
                service_name: serve.name,
                service_id: serve.id,
                service_question: squestions
              };
              ser_id.push(obj);
            });
            consultant_services_data.push({
              consultant_id: consultant.id,
              consultant_name: consultant.name,
              services: this.service,
              work_instructions_text:
                consultant.project_consultant.work_instructions_text,
              work_instructions_attachment:
                consultant.project_consultant.work_instructions_attachment,
              status: consultant.project_consultant.status_name,
              service_ids: ser_id
            });
          });
          this.consultant_services_array = consultant_services_data;
        }, 100);
        // Maping for images (for answers)

        project.consultants.forEach(eachCon => {
          eachCon.project_consultant.services.forEach(eachSer => {
            let dataQuestion = eachSer.project_consultant_service.questions.map(
              function(app) {
                if (
                  app.project_consultant_service_question.images != null &&
                  app.project_consultant_service_question.images.length != 0
                ) {
                  let images = [];
                  app.project_consultant_service_question.images.forEach(
                    element => {
                      if (element != null) {
                        images.push({
                          path: element,
                          s3_url: element
                        });
                      }
                    }
                  );
                  app.project_consultant_service_question.images = images;
                } else {
                  app.project_consultant_service_question.images = [];
                }
                return app;
              }
            );
            this.questions = project.consultants;
          });
        });
      }
    },
    // API Integration for Project Question Query Status
    async getProjectChangeQueryStatus(
      project_consultant_service_question_id,
      status
    ) {
      let input = {
        project_consultant_service_question_id,
        status
      };
      let url = "/projects/change-query-status/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.getProject();
      }
    },
    // API Integration for Project Question Comments
    async addProjectQuestionComments() {
      let input = {
        project_consultant_service_question_id: this.filtered_questions[
          this.selected_question_index
        ].project_consultant_service_question.id,
        comment: this.comment
      };
      let url = "/projects/comment/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.comment = "";
        this.popupActive = false;
        this.getProject();
      }
    },
    // API Integration for section listing
    async getSections() {
      let input = {
        only_parents: true,
        with_children: true
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;
        let filteredSection = [];
        let first_obj = { id: 0, name: "All Sections" };
        filteredSection.push(first_obj);
        for (var i = 0; i < sections.length; i++) {
          let obj = { id: sections[i].id, name: sections[i].name };
          filteredSection.push(obj);
        }
        this.filterSection = filteredSection;
      }
    },
    // API Integration for Designations
    async getDesignations() {
      let input = {
        name: this.designation
      };
      let response = await this.getHTTPPostResponse(
        "/designations/list",
        input
      );
      if (response) {
        let designation_req = response.data.designations;
        let filteredDesignations = [];
        let first_obj = { id: "", name: "All Designation" };
        filteredDesignations.push(first_obj);
        for (var i = 0; i < designation_req.length; i++) {
          let obj = {
            id: designation_req[i].id,
            name: designation_req[i].name
          };
          filteredDesignations.push(obj);
        }
        this.filterDesignation = filteredDesignations;
      }
    },

    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return filename;
    },
    // Images Logic
    dataChange(data) {},
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    uploadImageSuccess(forData, index, fileList) {
      let fileImage = this.dataURLtoFile(
        fileList[index].path,
        fileList[index].name
      );
      var input = new FormData();
      input.append("directory", "listing");
      input.append("attachment", fileImage);
      this.axios
        .post("s3/upload", input)
        .then(response => {
          let data = response.data.data;

          fileList[index].s3_url = data.url;
          this.$vs.notify({
            title: "Success.",
            text: response.data.message,
            color: "success",
            position: "top-right"
          });
        })
        .catch(e => {
          this.showError(e);
        });
    },
    beforeRemove(index, done, fileList) {
      this.url = fileList[index].s3_url;
      this.index = index;
      this.remove_data = {
        index: index,
        done: done
      };
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.removeImage
      });
    },
    removeImage() {
      let input = {
        url: this.url
      };
      this.axios
        .post("s3/remove", input)
        .then(response => {
          // show notification only
          // if new image is deleted.
          this.remove_data.done();
          if (!this.remove_data.edit) {
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right"
            });
          }
          return "tttttt";
        })
        .catch(e => {
          this.images.splice(this.remove_data.index, 1);
          this.remove_data.done();
          this.showError(e);
        });
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}
h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}
.consultant-border {
  border-bottom: 2px solid #f8f8f8;
}
.question-feather {
  vertical-align: middle;
}
.label-center {
  align-self: center !important;
}
a,
a:hover {
  color: #626262;
  text-decoration: none;
}
.audio {
  -webkit-text-stroke-width: thin;
}
[type="file"] {
  height: 0;
  overflow: hidden;
  width: 0;
}

[type="file"] + label {
  background: #f15d22;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Poppins", sans-serif;
  font-size: inherit;
  font-weight: 600;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  position: relative;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  vertical-align: middle;
}
[type="file"] + label:hover {
  background-color: #d3460d;
}
[type="file"] + label.btn-1 {
  background-color: #f79159;
  box-shadow: 0 6px #f57128;
  -webkit-transition: none;
  transition: none;
}
[type="file"] + label.btn-1:hover {
  box-shadow: 0 4px #f57128;
  top: 2px;
}
.service-border {
  border-bottom: 2px solid #f6f6f6;
}
.audio-file {
  align-items: flex-end;
}
.answer-image {
  width: 100%;
}
.swiper-slide {
  width: 100% !important;
}
.raise-question {
  position: absolute;
  right: 21px;
}
.submit-btn {
  text-align: center;
}
.comment-avatar {
  word-break: break-all;
}
.add-query {
  box-shadow: none !important;
  border: 1px solid #f1f1f1;
}
</style>

